import React, {useCallback, useState} from 'react';
import cn from 'classnames';

import VariantModel from 'coreClasses/product/VariantModel';
import useGeolocalizedSizes from 'coreHooks/useGeolocalizedSizes';
import useHistory from 'coreHooks/useHistory';
import {Link} from 'coreUtils/adapters/router';

import {IProductSizes} from './IProductSizes';

import styles from './ProductSizes.module.scss';

const ProductSizes = ({product, classNames, hideUrl = false}: IProductSizes) => {
	const history = useHistory();
	const [linkHref, setLinkHref] = useState('javascript:void(0)');
	const geolocalizedSizes = useGeolocalizedSizes(product);
	const handleSizeClick = useCallback((e, url) => {
		const isCommandOrCtrlClick = e.metaKey || e.ctrlKey;

		if (!isCommandOrCtrlClick) {
			e.preventDefault();
			history.push(url);
		} else {
			window.open(url, '_blank');
		}
	}, []);

	return (
		<ul className={cn('product-sizes', styles['product-sizes'], classNames?.wrapperSizes)}>
			{product?.getVariants()?.map((variant: VariantModel) => {
				const variantUrl: string = variant.getProductUrl();
				const size = geolocalizedSizes[variant.getProductId()];
				const ats: number = variant.getAtsStockLevel();
				const isAvailable: boolean = ats > 0;
				const key: string = `${variant.getProductId()}-${size}`;
				const value = ats > 0 ? size : <del>{size}</del>;

				return (
					<li className={cn('product-sizes_item', classNames?.itemSize)} key={key}>
						{isAvailable &&
							(!hideUrl ? (
								<Link to={variantUrl}>{value}</Link>
							) : (
								<a
									href={linkHref}
									onClick={(e) => handleSizeClick(e, variantUrl)}
									onContextMenu={() => setLinkHref(variantUrl)}
									onTouchStart={() => setLinkHref(variantUrl)}
								>
									{value}
								</a>
							))}
						{!isAvailable && value}
					</li>
				);
			})}
		</ul>
	);
};

export default ProductSizes;
